var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExam = function SvgExam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 4.5H14.5C14.5 3.12109 13.3789 2 12 2C10.6211 2 9.5 3.12109 9.5 4.5H6.375C5.33984 4.5 4.5 5.33984 4.5 6.375V20.125C4.5 21.1602 5.33984 22 6.375 22H17.625C18.6602 22 19.5 21.1602 19.5 20.125V6.375C19.5 5.33984 18.6602 4.5 17.625 4.5ZM12 3.5625C12.5195 3.5625 12.9375 3.98047 12.9375 4.5C12.9375 5.01953 12.5195 5.4375 12 5.4375C11.4805 5.4375 11.0625 5.01953 11.0625 4.5C11.0625 3.98047 11.4805 3.5625 12 3.5625ZM16.7344 12.6172L11.1484 18.1562C10.9648 18.3398 10.668 18.3359 10.4844 18.1523L7.25781 14.8984C7.07422 14.7148 7.07812 14.418 7.26172 14.2344L8.37109 13.1328C8.55469 12.9492 8.85156 12.9531 9.03516 13.1367L10.832 14.9492L14.9727 10.8398C15.1562 10.6562 15.4531 10.6602 15.6367 10.8438L16.7383 11.9531C16.9219 12.1406 16.918 12.4336 16.7344 12.6172Z",
    fill: "#E4E7EC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exam.c7f54041.svg";
export { ForwardRef as ReactComponent };